import { Button } from '@unmind/design-system';
import { SSOOrigin, useSSO } from 'LoggedOut/UniversalLogin/useSSO';
import { rem } from 'polished';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const SSOButton = styled(Button)`
  width: 100%;
  margin-top: ${rem(24)};
`;

interface SignUpWithSSOButtonProps {
  variant?: 'primary' | 'secondary';
  /** Called on click, before SSO starts, for screens that need to reset state. */
  onClick?(): void;
  /**
   * Called when SSO fails to start (network, Auth0). `useSSO` always reports the
   * failure to Sentry; screens that can show a message to the user opt in here.
   */
  onError?(error: unknown): void;
}

export const SignUpWithSSOButton = ({
  variant,
  onClick,
  onError,
}: SignUpWithSSOButtonProps) => {
  const { t: translate } = useTranslation('logged_out');
  const { startSSO, ssoProviderName, loading } = useSSO();

  const buttonText = ssoProviderName
    ? translate('sign_up.sso_signup_button.sso_provider', {
        sso_provider: ssoProviderName,
      })
    : translate('sign_up.sso_signup_button.default');

  return (
    <SSOButton
      variant={variant}
      /* The organisation isn't known until the subdomain query settles, and
       * starting SSO without it would send the user to the wrong tenant. */
      loading={loading}
      disabled={loading}
      onClick={() => {
        onClick?.();

        void startSSO(SSOOrigin.SignUp, { onError });
      }}
      label={buttonText}
    />
  );
};
